import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, _params, classes) => ({
    subMessageContainer: {
        textAlign: 'center',
        display: 'flex',
        padding: `0 ${theme.spacing(2)}`,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: (_params === null || _params === void 0 ? void 0 : _params.isSubHeading) ? '56px' : 'initial',
        height: (_params === null || _params === void 0 ? void 0 : _params.isSubHeading) ? '56px' : 'initial',
        '@media(orientation: portrait)': {
            placeContent: 'unset',
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            padding: '14px 0',
            minHeight: (_params === null || _params === void 0 ? void 0 : _params.isSubHeading) ? '72px' : 'initial',
            height: (_params === null || _params === void 0 ? void 0 : _params.isSubHeading) ? '72px' : 'initial',
        },
        [`& .${classes.subMessageTitle}`]: Object.assign(Object.assign({}, theme.typography.small_bold), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.large_bold) }),
        [`& .${classes.subMessage}`]: Object.assign(Object.assign({}, theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.large_regular) }),
    },
    subMessageTitle: {},
    subMessage: {},
}));
export default useStyles;
